define('tinymce-plugins/wa5_image/upload-dialog',["dialogs", "ajax", "button-disabler", "tinymce-plugins/wa5_image/image-utils",
		'lib/event-emitter', 'session', 'file-utils', 'strings'],
		function(dialogs, ajax, buttonDisabler, imageUtils, EventEmitter, session, fileUtils, strings) {
	function UploadDialog() {
		EventEmitter.call(this);
		var self = this;
		var imageData;

		var dialog = dialogs.create('image-upload-dialog');
		showPage('image-select');

		var uploadInput = dialog.find('.image-upload-input');
		var urlButton = dialog.find('.image-url-button');

		uploadInput.change(function(e) {
			var files = uploadInput[0].files;
			if (files.length > 0) {
				var file = files[0];

				var maxSize = uploadInput.data('max-size');
				if (file.size > maxSize) {
					alert('Die ausgewählte Datei ist zu groß, maximal ' +
							fileUtils.formatFileSize(maxSize) + ' sind erlaubt.');
					clearFileInput();
					return;
				}
				var allowedExtensions = uploadInput.data('file-extensions').split(',');
				var extension = file.name.substr(file.name.lastIndexOf('.') + 1).toLowerCase();
				if (allowedExtensions.indexOf(extension) < 0) {
					alert('Dieser Dateityp wird nicht unterstützt, erlaubt sind ' +
							allowedExtensions.join(', ') + '.');
					clearFileInput();
					return;
				}

				uploadInput.attr('disabled', true);
				urlButton.attr('disabled', true);
				dialog.find('.image-upload-indicator').show();

				var fd = new FormData();
				fd.append("image", file);

				var xhr = ajax.post('/images/upload', fd);
				xhr.finished.then(function(json) {
					onUploaded(json);
				}).catch(function(e) {
					console.log(e);
					if (typeof e != 'object' || !e.isAbort) {
						alert(e ? e : 'Fehler beim Hochladen der Bilddatei');
					}
				}).then(function() {
					clearFileInput();
					dialog.find('.image-upload-indicator').hide();
					urlButton.attr('disabled', false);
					uploadInput.attr('disabled', false);
				});

				dialog.find('.image-upload-cancel-button').click(function() {
					xhr.abort();
				});
			}
		});

		function clearFileInput() {
			uploadInput.replaceWith(uploadInput = uploadInput.clone(true));
		}

		urlButton.click(function(e) {
			buttonDisabler.disable(urlButton);
			uploadInput.attr('disabled', true);
			var url = dialog.find('.image-url-input').val();
			ajax.post('/images/fetch', { url: url }).finished.then(function(json) {
				onUploaded(json);
			}).catch(function(e) {
				console.log(e);
				alert(e ? e : 'Fehler beim Hochladen der Bilddatei');
			}).then(function() {
				buttonDisabler.enable(urlButton);
				uploadInput.attr('disabled', false);
			});
		});

		var insertButton = dialog.find('.insert-image-button');
		insertButton.click(function(e) {
			self.emit('insert', readMetadataFromForm());
			dialogs.close(dialog);
		});

		dialog.find('.cancel-button').click(function() {
			dialogs.close(dialog);
		});

		dialog.find('input').on('change keypress keyup', updateButtons);

		dialog.find('.back-button').click(function() {
			showPage('image-select');
			dialog.find('.back-button').hide();
		});

		function showPage(pageName) {
			dialog.find('.page-control .page').hide();
			dialog.find('.page-control .' + pageName + '-page').show();
			dialog.find('.arrow-steps .step').removeClass('current');
			dialog.find('.arrow-steps .' + pageName + '-step').addClass('current');

			dialog.find('.insert-image-button').toggle(pageName == 'metadata');
		}

		function onUploaded(result) {
			imageData = result;
			showPage('metadata');
			assignMetadata(result);
			showPreview(result);
			dialog.find('.back-button').show();
		}

		function assignMetadata(metadata) {
			checkRadioButton('.image-ownwork-true', metadata.ownwork);
			checkRadioButton('.image-ownwork-false', metadata.ownwork === false);
			dialog.find('input[name=source]').val(metadata.source);
			dialog.find('input[name=author]').val(metadata.author);
			var isCC = metadata.license && strings.startsWith(metadata.license, 'cc-');
			checkRadioButton('input[name=category][value=cc]', isCC);
			if (isCC && metadata.license && metadata.license.match(/^[a-z0-9\.-]+$/) /* sanitize */) {
				checkRadioButton('input[name=license][value="' + metadata.license + '"]', true);
			} else if (metadata.license == 'public-domain') {
				checkRadioButton('input[name=category][value=public-domain]', true);
			}
		}

		function readMetadataFromForm() {
			// re-use imageData element because it may contian more attributes (e.g. width and
			// height) that should not be discarded

			if (dialog.find('.image-ownwork-true').is(':checked')) {
				imageData.ownwork = true;
				imageData.license = 'cc-by-sa-3.0';
				imageData.author = session.user;
				imageData.source = '';
			} else {
				imageData.author = dialog.find('input[name=author]').val();
				imageData.source = dialog.find('input[name=source]').val();
				imageData.ownwork = false;

				if (dialog.find('input[name=category][value=public-domain]').is(':checked')) {
					imageData.license = 'public-domain';
				} else {
					imageData.license = dialog.find('input[name=license]:checked').val();
				}
			}

			return imageData;
		}

		function checkRadioButton(selector, checked) {
			var radio = dialog.find(selector);
			if (radio.length) {
				radio[0].checked = checked;
				radio.trigger('change');
			}
		}

		function showPreview(result) {
			dialog.find('.image-preview').empty().append(
					$('<img>').attr('src', imageUtils.getImageURL(result)));
		}

		function updateButtons() {
			$('.insert-image-button').prop('disabled', !validateCheckboxes());
		}

		function validateCheckboxes() {
			if (dialog.find('.image-ownwork-true').is(':checked')) {
				return true;
			}

			if (dialog.find('input[name=category][value=public-domain]').is(':checked')) {
				return true;
			}

			if (dialog.find('input[name=category][value=cc]').is(':checked')) {
				var checkedLicense = dialog.find('input[name=license]:checked').val();
				if (!checkedLicense || checkedLicense == 'unknown') {
					return false;
				}

				var author = dialog.find('input[name=author]').val().trim();
				if (checkedLicense.indexOf('-by-') >= 0 && !author) {
					return false; // TODO indicate that author is missing
				}

				return true;
			}
		}

		this.showUpload = function() {
			dialog.find('.back-button').hide();
			dialogs.showModal(dialog);
		};

		this.showEditor = function(data) {
			dialog.find('.insert-image-button').text('Änderungen übernehmen');
			onUploaded(data);
			dialog.find('.back-button').hide(); // is not possible when editing
			dialogs.showModal(dialog);
		};
	}

	UploadDialog.prototype = Object.create(EventEmitter.prototype);

	return UploadDialog;
});

